export interface SiteContactItem {
  label: string;
  value: string;
  href?: string;
}

export interface SiteSocialLink {
  label: string;
  href: string;
}

export const homeSectionIds = {
  hero: "oxyDtvm",
  solutions: "solucoes",
} as const;

export const siteTemporaryAnnouncement = "Fase de habilitação na CVM";

export const siteEmailContacts = {
  institutional: {
    label: "Institucional",
    value: "institucional@oxydtvm.com.br",
    href: "mailto:institucional@oxydtvm.com.br",
  },
  commercial: {
    label: "Comercial",
    value: "comercial@oxydtvm.com.br",
    href: "mailto:comercial@oxydtvm.com.br",
  },
  custodian: {
    label: "Custódia",
    value: "custodiante@oxydtvm.com.br",
    href: "mailto:custodiante@oxydtvm.com.br",
  },
  escrituracao: {
    label: "Escrituração",
    value: "escrituracao@oxydtvm.com.br",
    href: "mailto:escrituracao@oxydtvm.com.br",
  },
  ombudsman: {
    label: "Ouvidoria",
    value: "ouvidoria@oxydtvm.com.br",
    href: "mailto:ouvidoria@oxydtvm.com.br",
  },
  finance: {
    label: "Financeiro",
    value: "financeiro@oxydtvm.com.br",
    href: "mailto:financeiro@oxydtvm.com.br",
  },
  accounting: {
    label: "Contabilidade",
    value: "contabilidade@oxydtvm.com.br",
    href: "mailto:contabilidade@oxydtvm.com.br",
  },
  hr: {
    label: "Recursos Humanos",
    value: "rh@oxydtvm.com.br",
    href: "mailto:rh@oxydtvm.com.br",
  },
  compliance: {
    label: "Compliance",
    value: "compliance@oxydtvm.com.br",
    href: "mailto:compliance@oxydtvm.com.br",
  },
  lgpd: {
    label: "LGPD",
    value: "lgpd@oxydtvm.com.br",
    href: "mailto:lgpd@oxydtvm.com.br",
  },
  technology: {
    label: "TI",
    value: "ti@oxydtvm.com.br",
    href: "mailto:ti@oxydtvm.com.br",
  },
} as const satisfies Record<string, SiteContactItem>;

export const sitePhoneContacts = {
  institutional: {
    label: "Telefone",
    value: "(11) 5460-2222",
    href: "tel:+551154602222",
  },
  toll_free: {
    label: "0800",
    value: "0800 460 2222",
    href: "tel:08004602222",
  },
} as const satisfies Record<string, SiteContactItem>;

export const siteContact = {
  address:
    "Avenida Plínio Brasil Milano, 567, Sala 1001, Porto Alegre/RS - 90450-085",
  phones: [sitePhoneContacts.institutional, sitePhoneContacts.toll_free],
  phoneSummary: sitePhoneContacts.institutional.value,
  email: siteEmailContacts.commercial.value,
  emailHref: siteEmailContacts.commercial.href,
  dpoEmail: siteEmailContacts.lgpd.value,
  dpoEmailHref: siteEmailContacts.lgpd.href,
};

export const siteSocialLinks: SiteSocialLink[] = [
  { label: "LinkedIn", href: "https://linkedin.com" },
  { label: "Instagram", href: "https://instagram.com" },
];

export const siteRegulatoryText = [
  'A OXY DTVM é instituição financeira autorizada a funcionar pelo Banco Central do Brasil ("BCB") e, conforme aplicável, exerce atividades reguladas pela Comissão de Valores Mobiliários ("CVM"), incluindo a prestação dos serviços de: (i) administração fiduciária, (ii) gestão de recursos de terceiros e (iii) agente fiduciário, dentre outros.',
  "Os créditos estruturados não contam com garantia do agente fiduciário, de qualquer mecanismo de seguro ou do Fundo Garantidor de Créditos (FGC). A rentabilidade divulgada não é líquida de impostos, e os resultados obtidos no passado não representam garantia de rentabilidade futura. Investimentos em valores mobiliários envolvem riscos, inclusive o risco de perda do capital investido. Recomenda-se a leitura cuidadosa do regulamento, prospecto, termo de securitização, termo de emissão e demais documentos pertinentes antes de aplicar recursos. As informações disponibilizadas neste site têm caráter exclusivamente informativo e não devem, em hipótese alguma, ser interpretadas como recomendação de investimento ou oferta de compra ou venda de quaisquer valores mobiliários ou produtos financeiros.",
  "Toda transmissão de ordem por meio digital está sujeita a interrupções ou atrasos, podendo impedir ou prejudicar o envio de ordens ou a recepção de informações atualizadas. As informações e os dados pessoais fornecidos por meio deste site serão tratados em conformidade com a Política de Privacidade da OXY DTVM.",
];
